import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class TabChangeService {

  /*public tabChange:EventEmitter = new EventEmitter();*/

  constructor() {
  }


}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/tab-change.service.ts